<template>
  <div class="partnet-point-logs">
    <p v-if="isLoading">
      <Loading />
    </p>
    <template v-else>

      <Tabs />

      <div class="partnet-point-logs__filters d-flex justify-content-between">
        <button v-b-modal.modal-filter-type>{{ filterType }}

          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033L8.53033 10.5303C8.38968 10.671 8.19891 10.75 8 10.75C7.80109 10.75 7.61032 10.671 7.46967 10.5303L3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967C3.76256 5.17678 4.23744 5.17678 4.53033 5.46967L8 8.93934L11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967Z"
              fill="#666666" />
          </svg>

        </button>

        <button v-b-modal.modal-filter-date>{{ filterDate }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033L8.53033 10.5303C8.38968 10.671 8.19891 10.75 8 10.75C7.80109 10.75 7.61032 10.671 7.46967 10.5303L3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967C3.76256 5.17678 4.23744 5.17678 4.53033 5.46967L8 8.93934L11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967Z"
              fill="#666666" />
          </svg>

        </button>
      </div>

      <!-- 會員卡區塊 -->
      <div v-if="memberCard" class="s-p-3 pb-0">
        <div class="s-bg-white rounded rounded-2 d-flex align-items-center member-card-block">
          <img :src="require('@/assets/images/partner-marketing/member-card-normal.png')" alt="會員卡" class="member-card-icon">
          <div class="member-card-text">數位會員卡 {{ memberCard.card_number }}</div>
        </div>
      </div>

      <div class="s-p-3">
        <!-- 兌換紀錄列表 -->
        <div v-for="log in logs" :key="log.id" class="s-bg-white s-mb-3 partnet-point-logs__log">
          <div class="d-flex justify-content-between align-items-center s-mb-2">
            <div class="partnet-point-logs__log__title">{{ log.title }}</div>
            <div class="s-text-secondary partnet-point-logs__log__desc">{{ log.points }}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="partnet-point-logs__log__desc">
              <div>兌換序號：{{ log.serial_number }}</div>
              <div v-if="log.expired_at">序號到期：{{ log.expired_at }}</div>
            </div>
            <div>
              <!-- 根據 type 顯示不同按鈕 -->
              <CopyButton
                v-if="log.type === 'serial'"
                :text="log.serial_number"
                variant="logs"
                success-message="序號已複製到剪貼簿"
              />

              <button v-else-if="log.type === 'product'"
                class="s-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3"
                @click="showBarcode(log)">開啟</button>
            </div>
          </div>
        </div>

        <!-- 空狀態顯示 -->
        <div v-if="!isLoading && logs.length === 0" class="text-center py-5 text-muted">
          暫無兌換紀錄
        </div>
      </div>

      <!-- 使用共用 Barcode Popup 組件 -->
      <BarcodePopup
        :show="showBarcodeModal"
        :serial-number="selectedLog ? selectedLog.serial_number : ''"
        @close="closeBarcodeModal"
        @copied="onBarcodeCopied"
      />


      <b-modal id="modal-filter-type" centered>

        <template #modal-header="{ close }">


          <div>選擇查詢分類</div>
          <!-- 模擬內建 modal 標題關閉按鈕動作 -->
          <b-button variant="link" @click="close()" class="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                fill="#666666" />
            </svg>

          </b-button>


        </template>

        <div class="px-3 pt-3">

          <b-form-radio v-for="(i, idx) in filterOptions.type" v-model="filterType" :key="idx" :value="i"
            class="mb-3">{{ i
            }}</b-form-radio>

        </div>

        <template #modal-footer="{ close }">
          <div class="w-100">
            <button class="s-btn s-btn-primary s-btn-sm px-4" @click="onTypeFilterConfirm(close)">確認</button>
          </div>
        </template>
      </b-modal>


      <b-modal id="modal-filter-date" centered>

        <template #modal-header="{ close }">


          <div>選擇查詢區間</div>
          <!-- 模擬內建 modal 標題關閉按鈕動作 -->
          <b-button variant="link" @click="close()" class="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                fill="#666666" />
            </svg>

          </b-button>


        </template>

        <div class="px-3 pt-3">

          <b-form-radio v-for="(i, idx) in filterOptions.date" v-model="filterDate" :key="idx" :value="i"
            class="mb-3">{{ i
            }}</b-form-radio>

        </div>

        <template #modal-footer="{ close }">
          <div class="w-100">
            <button class="s-btn s-btn-primary s-btn-sm px-4" @click="onDateFilterConfirm(close)">確認</button>
          </div>
        </template>
      </b-modal>

    </template>
  </div>
</template>

<script>
import Loading from '@/components/Page/Liff/Shared/Loading'
import Tabs from '@/components/Page/Web/PartnerMarketing/Tabs.vue'
import BarcodePopup from '@/components/Page/Web/PartnerMarketing/BarcodePopup.vue'
import CopyButton from '@/components/Page/Web/PartnerMarketing/CopyButton.vue'
import webPartnerMarketing from '@/apis/web/partnerMarketing'

export default {
  components: { Loading, Tabs, BarcodePopup, CopyButton },
  data: () => ({
    logs: [],                // 兌換紀錄列表
    isLoading: false,        // 載入狀態
    showBarcodeModal: false, // Barcode popup 顯示狀態
    selectedLog: null,       // 選中的 log 資料
    memberCard: null,        // 會員卡資料
    filterType: '全部',
    filterDate: '最近6個月',
    filterOptions: {
      type: [
        "全部",
        "點數轉入紀錄",
        "點數轉出紀錄",
      ],
      date: [
        "最近1個月",
        "最近3個月",
        "最近6個月"
      ]
    },
    filterMapping: {
      type: {
        '全部': null,
        '點數轉入紀錄': 'poya',
        '點數轉出紀錄': 'exchange'
      },
      period: {
        '最近1個月': '1month',
        '最近3個月': '3months',
        '最近6個月': '6months'
      }
    }
  }),
  mounted() {
    document.title = '兌換記錄查詢';
    this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      this.isLoading = true
      try {
        const filters = this.buildFilters()
        const response = await webPartnerMarketing.getLogs(filters)

        this.logs = response.data.data.logs
        this.memberCard = response.data.data.member_card
      } catch (error) {
        console.error('載入兌換紀錄失敗:', error)
      } finally {
        this.isLoading = false
      }
    },

    buildFilters() {
      const filters = {}

      // 分類過濾
      if (this.filterType !== '全部') {
        filters.type = this.filterMapping.type[this.filterType]
      }

      // 時間過濾
      filters.period = this.filterMapping.period[this.filterDate]

      return filters
    },

    onTypeFilterConfirm(closeModal) {
      closeModal()
      this.fetchLogs() // 重新載入資料
    },

    onDateFilterConfirm(closeModal) {
      closeModal()
      this.fetchLogs() // 重新載入資料
    },

    // 顯示 Barcode popup（product type）
    showBarcode(log) {
      this.selectedLog = log
      this.showBarcodeModal = true
    },

    // 關閉 Barcode popup
    closeBarcodeModal() {
      this.showBarcodeModal = false
      this.selectedLog = null
    },

    // Barcode 複製完成回調
    onBarcodeCopied() {
      // 可選擇是否關閉 modal
      // this.closeBarcodeModal()
    }
  }
}
</script>

<style lang="scss" scoped>
.partnet-point-logs {
  margin: -1rem -0.75rem 0;

  &__filters {

    background-color: white;
    border-top: 1px solid #E3E3E3;

    font-weight: 500;
    font-size: 14px;
    padding: 12px;


    button {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }


  &__log {
    padding: 12px;

    &__title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }

    &__point {
      font-weight: 500;
      font-size: 14px;      
    }

    &__desc {

      font-weight: 500;
      font-size: 12px;
      color: #999999;

    }
  }
}



.s-text-secondary {
  color: #FE577F !important;
}


::v-deep .modal-backdrop {
  opacity: .5;
}

::v-deep .modal {
  overflow-x: hidden !important;
  overflow-y: hidden !important;

  --s-primary: #FE577F;


  &.fade .modal-dialog {
    transform: translateY(10%);
    transition: transform 0.3s ease-out;
  }

  &.show .modal-dialog {
    transform: translateY(0);
  }


  .modal-dialog {
    margin: auto;
    max-width: 90%;

    .modal-header {
      justify-content: center;
      align-items: center;
      position: relative;

      .close {
        position: absolute;
        right: 0;
        margin: 0;
      }
    }

    .modal-content {
      border-radius: .3rem .3rem 0 0;
      border: none;
    }

    &.modal-dialog-centered {
      align-items: end;
      justify-content: center;
      min-height: calc(100%);
    }
  }

  .s-btn {
    color: white !important;
  }


}

.member-card-icon {
  width: 30px;
  height: 18px;
}

.member-card-text {
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0px;
  margin-left: 12px;
}

.member-card-block {
  padding: 16px 12px;
}
</style>
